import { z } from 'zod'

export const themeEnum = z.enum(['light', 'dark', 'system'])

export const primaryColorEnum = z.enum([
  'orange',
  'red',
  'blue',
  'green',
  'purple',
  'pink',
  'yellow',
  'cyan',
  'indigo',
])

export const aparenciaSchema = z.object({
  theme: themeEnum,
  primaryColor: primaryColorEnum,
  sidebarCompact: z.boolean().optional(),
  animationsEnabled: z.boolean().optional(),
})

export type AparenciaFormData = z.infer<typeof aparenciaSchema>

export const defaultAparencia: AparenciaFormData = {
  theme: 'system',
  primaryColor: 'red',
  sidebarCompact: false,
  animationsEnabled: true,
}

// Color palette definitions with HSL/OKLCH values for each primary color
export const PRIMARY_COLORS: Record<
  z.infer<typeof primaryColorEnum>,
  { name: string; class: string; lightValue: string; darkValue: string; hex: string }
> = {
  orange: {
    name: 'Laranja',
    class: 'bg-orange-500',
    lightValue: 'oklch(0.55 0.2 25)',
    darkValue: 'oklch(0.65 0.2 25)',
    hex: '#ea580c',
  },
  red: {
    name: 'Vermelho',
    class: 'bg-red-500',
    lightValue: 'oklch(0.55 0.22 27)',
    darkValue: 'oklch(0.6 0.22 27)',
    hex: '#dc2626',
  },
  blue: {
    name: 'Azul',
    class: 'bg-blue-500',
    lightValue: 'oklch(0.55 0.2 250)',
    darkValue: 'oklch(0.65 0.2 250)',
    hex: '#2563eb',
  },
  green: {
    name: 'Verde',
    class: 'bg-green-500',
    lightValue: 'oklch(0.55 0.18 145)',
    darkValue: 'oklch(0.65 0.18 145)',
    hex: '#16a34a',
  },
  purple: {
    name: 'Roxo',
    class: 'bg-purple-500',
    lightValue: 'oklch(0.55 0.2 300)',
    darkValue: 'oklch(0.65 0.2 300)',
    hex: '#9333ea',
  },
  pink: {
    name: 'Rosa BxR',
    class: 'bg-[#FF3366]',
    lightValue: 'oklch(0.655 0.277 356)',
    darkValue: 'oklch(0.72 0.277 356)',
    hex: '#FF3366',
  },
  yellow: {
    name: 'Amarelo',
    class: 'bg-yellow-500',
    lightValue: 'oklch(0.75 0.18 85)',
    darkValue: 'oklch(0.8 0.18 85)',
    hex: '#eab308',
  },
  cyan: {
    name: 'Ciano',
    class: 'bg-cyan-500',
    lightValue: 'oklch(0.6 0.15 200)',
    darkValue: 'oklch(0.7 0.15 200)',
    hex: '#0891b2',
  },
  indigo: {
    name: 'Índigo',
    class: 'bg-indigo-500',
    lightValue: 'oklch(0.5 0.2 270)',
    darkValue: 'oklch(0.6 0.2 270)',
    hex: '#4f46e5',
  },
}

export const THEME_LABELS: Record<z.infer<typeof themeEnum>, string> = {
  light: 'Claro',
  dark: 'Escuro',
  system: 'Automático',
}
